import { getSettings } from 'settings/AppSettings';

const getJceWebBaseUrl = () => getSettings(__ENV__).JCE_WEB_BASE_URL;

export default getJceWebBaseUrl;
